export const Types = {
   UPLOAD_FILE:"UPLOAD_FILE",
   LIST_TESTS:"LIST_TESTS"
  };